
import { ReactNode } from 'react';
import SearchSelect from 'react-select';

export interface OptionValueType {
    label: string;
    value: string | number;
}

export interface SearchInputType {
    options: Array<OptionValueType>,
    placeholder?: string;
    value?: any;
    isClearable?: boolean;
    isLoading?: boolean;
    loadingMessage?: (obj: { inputValue: string; }) => ReactNode;
    isDisabled?: boolean;
    required?: boolean;
    isMulti?: boolean;

    borderColor?: string;
    size?: "sm" | "md" | "lg";


    onChange?: (e: any) => void;
    onFocus?: (e: any) => void;
    onBlur?: (e: any) => void;
    onInputChange?: (e: any) => void;
    onKeyDown?: (e: any) => void;
    onMenuOpen?: () => void;
    onMenuClose?: () => void;
}

export default function SearchInput(props: SearchInputType) {
    const customStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            borderColor: props.borderColor ?? '#e3e3e3',
            minHeight: props.size === "sm" ? '24px' : (props.size === "md" ? '30px' : props.size === "lg" ? '35px' : '35px'),
            height: props.size === "sm" ? '24px' : (props.size === "md" ? '30px' : props.size === "lg" ? '35px' : '35px'),
            boxShadow: state.isFocused ? null : null,
            borderRadius: "0px",
        }),

        valueContainer: (provided: any, state: any) => ({
            ...provided,
            height: props.size === "sm" ? '24px' : (props.size === "md" ? '30px' : props.size === "lg" ? '35px' : '35px'),
            padding: '0 6px'
        }),

        input: (provided: any, state: any) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: (state: any) => ({
            display: 'none',
        }),
        indicatorsContainer: (provided: any, state: any) => ({
            ...provided,
            height: props.size === "sm" ? '24px' : (props.size === "md" ? '30px' : props.size === "lg" ? '35px' : '35px'),
        }),
    };
    
    return (
        <SearchSelect
            {...props}
            className={"searchInput"}
            styles={customStyles}
            value={props.options.find(s => s.value === props?.value)}
        />
    )
}